import {
  formatSignedSkuContextQuantity,
  formatSkuContextDetailStatus,
  formatSkuContextKind,
  type InventoryDiscrepancySkuContextRowWithRunningTotal,
} from "./inventoryDiscrepancySkuContext";

export function downloadSkuInventoryTransactionContextCsv(
  skuId: string,
  rows: InventoryDiscrepancySkuContextRowWithRunningTotal[],
): void {
  const header = ["occurred_at", "kind", "reference", "quantity", "on_hand", "in_house", "status"];
  const lines = [
    header.join(","),
    ...rows.map((row) =>
      [
        row.occurred_at ?? "",
        formatSkuContextKind(row.kind),
        row.reference ?? "",
        formatSignedSkuContextQuantity(row),
        row.on_hand_total ?? "",
        row.in_house_total ?? "",
        formatSkuContextDetailStatus(row.detail),
      ]
        .map((cell) => `"${String(cell).replaceAll('"', '""')}"`)
        .join(","),
    ),
  ];
  const blob = new Blob([lines.join("\n")], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = `${skuId.replaceAll(/[/\\]/g, "-")}-transaction-context.csv`;
  anchor.click();
  URL.revokeObjectURL(url);
}
